import React, { Component } from 'react';
import './calculadora.css';
import { Spring } from 'react-spring/renderprops';

export default class CalculadoraParalelo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ResistorA_valor: "0",
      ResistorB_valor: "0",
      ResultadoValor: "0 Ω",
    }

    this.calcular = this.calcular.bind(this);
  }
  handleKeyPress = (e) => {
    let tecla = e.key;
    if (tecla === 'Enter') {
      this.calcular();
    }
  }
  calcular() {
    let ResultadoValor;
    let ResiA_valor = this.state.ResistorA_valor ? parseFloat(this.state.ResistorA_valor) : 0;
    let ResiB_valor = this.state.ResistorB_valor ? parseFloat(this.state.ResistorB_valor) : 0;
    let ResiA = ResiA_valor ? ResiA_valor : 0;
    let ResiB = ResiB_valor ? ResiB_valor : 0;
    if (ResiA === 0 && ResiB !== 0) {
      ResultadoValor = ResiB_valor;
    } else if (ResiB === 0 && ResiA !== 0) {
      ResultadoValor = ResiA_valor;
    } else if (ResiB !== 0 && ResiA !== 0) {
      let Rma, Rme;
      if (ResiA > ResiB) {
        Rma = ResiA;
        Rme = ResiB;
      } else {
        Rma = ResiB;
        Rme = ResiA;
      }
      let Rdiv;
      Rdiv = Rma / Rme + 1;
      ResultadoValor = (Rma / Rdiv).toFixed(2);
    } else {
      ResultadoValor = 0;
    }
    if (ResultadoValor >= 1000000) {
      ResultadoValor /= 1000000;
      ResultadoValor += " MΩ";
    }
    else if (ResultadoValor >= 1000 && ResultadoValor < 1000000) {
      ResultadoValor /= 1000;
      ResultadoValor += " kΩ";
    } else {
      ResultadoValor += " Ω";
    }
    this.setState({ ResultadoValor })
  }

  render() {
    return (
      <Spring
        config={{ tension: 280, friction: 60, delay: 1000 }}
        from={{ opacity: 0, marginTop: -500 }}
        to={{ opacity: 1, marginTop: 0 }}
      >
        {props => (
          <div style={props}>
            <div className="calculadora">
              <h1> Associação de Resistores em Paralelo </h1>
              <input type="number" className="TextBox" onKeyPress={this.handleKeyPress} onChange={(event) => { this.setState({ ResistorA_valor: event.target.value }) }}></input>
              <input type="number" className="TextBox" onKeyPress={this.handleKeyPress} onChange={(event) => { this.setState({ ResistorB_valor: event.target.value }) }}></input>
              <input type="button" className="Botao" value="Calcular" onClick={this.calcular}></input>
              <h2>{this.state.ResultadoValor.toString()}</h2>
            </div>
          </div>
        )}
      </Spring>
    );
  }
}